import { ReferralType } from '@wix/da-bi/pkg/constants';

export type SisuActionKey =
  | 'download'
  | 'comment'
  | 'favourite'
  | 'add_to_group'
  | 'add_to_private_collection'
  | 'award_badge'
  | 'share_to_post'
  | 'report'
  | 'default';

export function getSisuActionKey(referralType?: ReferralType): SisuActionKey {
  switch (referralType) {
    case ReferralType.ANON_DOWNLOAD:
      return 'download';
    case ReferralType.COMMENT:
    case ReferralType.COMMENT_ACTION:
      return 'comment';
    case ReferralType.FAVOURITE:
      return 'favourite';
    case ReferralType.ADD_TO_GROUP:
      return 'add_to_group';
    case ReferralType.ADD_TO_PRIVATE_COLLECTION:
      return 'add_to_private_collection';
    case ReferralType.AWARD_BADGE:
      return 'award_badge';
    case ReferralType.SHARE_TO_POST:
      return 'share_to_post';
    case ReferralType.REPORT:
      return 'report';
    default:
      return 'default';
  }
}
